module.exports = "/lucky-balls/img/weager/Lower_Raise/Button_Higher.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Lower_Raise/Button_Higher.png
// module id = 1161
// module chunks = 0